import styles from './EventDisplay.module.css';

export const EventHelp = () => {
  return (
    <div className={styles.eventInfoCard}>
      <div className={styles.rightBlock}>
        <b>Need any help?</b>
        <div>
          Contact us at <a href="mailto:info@careerbook.co.uk">info@careerbook.co.uk</a>
        </div>
      </div>
    </div>
  );
};
